import { useSelector } from 'react-redux'
import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material'

import GridHeader from '../components/GridHeader'
import SelectionBar from '../components/selection/SelectionBar'
import SortableTableHead from '../components/SortableTableHead'
import GridCircularProgress from '../components/GridCircularProgress'
import { useGetCategorieQuery } from '../hooks/api-slice'
import { sortCodiceSocieta } from '../hooks/sort-functions'
import { useGetIscrizioniQuery } from '../hooks/api-slice'
import { getCategorie } from '../hooks/selection-get-functions'
import { config } from '../settings/configs'
import { colours } from '../settings/settings'

let columnsSquadre = [
  { label: 'Progressivo', sortable: false },
  { label: 'Codice società', sortable: false },
  { label: 'Nome squadra', sortable: false },
]

const Squadre = () => {
  const { data: categorie } = useGetCategorieQuery()
  const selectedCampionato = useSelector(
    state => state.selection.selectedCampionato,
  )
  const { data: iscrizioniLight, isLoading } = useGetIscrizioniQuery(
    { campionato: selectedCampionato, iFilter: 'nomi' },
    { skip: !selectedCampionato },
  )
  const availableCategorie = useSelector(
    state => state.selection.availableCategorie,
  )
  const selectedCategoria = useSelector(
    state => state.selection.selectedCategoria,
  )
  document.title = `${config?.name} - Squadre`

  const SquadreTable = ({ categoria }) => {
    const squadreTable = iscrizioniLight
      ?.filter(i => i.categoria === categoria)
      ?.sort((a, b) => sortCodiceSocieta(a.codiceSocieta, b.codiceSocieta))
      ?.map((i, index) => ({
        index: index + 1,
        codiceSocieta: i.codiceSocieta,
        nomeSquadra: i.nomeSquadra,
      }))

    const squadreCategoria =
      categorie?.find(c => c.categoria === categoria)?.nome || categoria

    return (
      <Grid size={12}>
        <h4>Categoria {squadreCategoria}</h4>
        <TableContainer component={Paper}>
          <Table size='small'>
            <SortableTableHead table={squadreTable} columns={columnsSquadre} />
            <TableBody>
              {squadreTable.map((s, index) => {
                return (
                  <TableRow
                    key={index}
                    style={{ backgroundColor: colours.white }}
                  >
                    <TableCell sx={{ width: '15vw' }}>{s.index}</TableCell>
                    <TableCell sx={{ width: '15vw' }}>
                      {s.codiceSocieta}
                    </TableCell>
                    <TableCell>{s.nomeSquadra}</TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    )
  }

  return (
    <Grid container paddingX={2} spacing={2} sx={{ width: '100%' }}>
      <GridHeader h2 text='Squadre iscritte' />
      <Grid container alignItems='center' sx={{ width: '100%' }}>
        <SelectionBar data={iscrizioniLight} yCampionato yCategoria />
      </Grid>
      {(isLoading && <GridCircularProgress />) ||
        (!iscrizioniLight && (
          <GridHeader text='Squadre iscritte non trovate.' />
        )) ||
        (iscrizioniLight.length === 0 && (
          <GridHeader text='Nessuna squadra iscritta.' />
        )) || (
          <>
            {!!selectedCategoria && (
              <Grid
                container
                spacing={3}
                justifyContent='center'
                sx={{ width: '100%' }}
              >
                {getCategorie(
                  iscrizioniLight.filter(i =>
                    !!selectedCategoria &&
                    selectedCategoria !== availableCategorie[0]
                      ? i.categoria === selectedCategoria
                      : true,
                  ),
                ).map(categoria => (
                  <Grid size={12} key={categoria}>
                    <SquadreTable categoria={categoria} />
                  </Grid>
                ))}
              </Grid>
            )}
          </>
        )}
    </Grid>
  )
}

export default Squadre
